import React, { useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { useAdminLanguage } from "../../../context/AdminLanguageContext";
import StatsGridService from "../../../services/StatsGridService";
import AdminGridBoardService from "../board/AdminGridBoardService";
import BedrockIdeaService from "../../setting/bedrock_idea/BedrockIdeaService";
import WordPuzzleTagStatsPanel from "../../pzl_common/stats/WordPuzzleTagStatsPanel";

const GRID_TYPE_FILTER_OPTIONS = [
    { value: "", label: "All" },
    { value: "HIDDEN_MESSAGE", label: "Hidden Message" },
    { value: "WORD_SEARCH", label: "Word Search" },
];

export default function AdminGridStatsMain() {
    const { language } = useAdminLanguage();
    const fetchStats = useCallback((lang, puzzleType) => StatsGridService.statsByTag(lang, puzzleType), []);
    const publishReviewed = useCallback(
        (batchSize, lang, tag, puzzleType) =>
            AdminGridBoardService.publishReviewed(batchSize, lang, tag, puzzleType),
        [],
    );
    const generateIdea = useCallback((tag) => BedrockIdeaService.genDraftByTag(tag, "grid"), []);

    return (
        <Box
            sx={{
                p: 2,
                minHeight: "100%",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Typography variant="h5" sx={{ fontWeight: 600, color: "primary.main", mb: 1, flexShrink: 0 }}>
                Grid Statistics
            </Typography>
            <WordPuzzleTagStatsPanel
                language={language}
                fetchStats={fetchStats}
                publishReviewed={publishReviewed}
                generateIdea={generateIdea}
                dashboardPath="/admin/puzzle/grid_board"
                puzzleLabel="grid"
                sortStorageKey="admin.grid.tagStats.sort"
                typeFilterOptions={GRID_TYPE_FILTER_OPTIONS}
            />
        </Box>
    );
}
